

import {
  Trans
} from '@/plugins/Translation'

export default {


  getimage(img){

          var images = require.context('../../../assets/images', false, /\.png$/)
          var url = images('./' + img + ".png");
          return images('./' + img + ".png")
  },

  getparabirimi() {
    var cred = JSON.parse(window.localStorage.getItem('credentials'))
    var birim = 'TRY'
    if (birim == 'TRY') {
      return '₺'
    } else if (birim == 'EUR') {
      return '€'
    } else if (birim == 'USD') {
      return '$'
    } else {
      return '₺'
    }
  },

  base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  },



  getDateTimeNow() {
    var tarih = this.getDateNow();

    var time = new Date();

    var saat = time.toLocaleTimeString("tr-TR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
    return tarih + 'T' + saat
  },


  isdateok: function (t) {

    var a = new Date(t)

    var yil = a.getFullYear()
    var ay = a.getMonth()
    var gun = a.getDay()

    if (isNaN(yil) && isNaN(ay) && isNaN(gun)) {
      return t;
    } else {
      return this.dateformat(t);
    }
  },
  adddays(days) {
    var date = new Date();
    date.setDate(date.getDate() + days);

    var today = new Date(date);

    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd

    return today

  },

  getaktifdil() {
    return Trans.getaktifdil();
  },
  getTime(a) {

    if (a != null) {

      if (a == '0001-01-01T00:00:00') {
        return null
      } else {

        if (a.length > 5) {
          var bastarih = a.split("T")
          if (bastarih[1] != '00:00:00') {

            var saat = bastarih[1].split(":")
            return saat[0] + ':' + saat[1]
          } else {
            return null
          }

        } else {
          return a
        }

      }
    } else {
      return null
    }
  },

  dateformat: function (t) {

    if (t != '0001-01-01T00:00:00' && t != '' && t != null) {
      var date = new Date(t);
      var fulldate = date.toLocaleDateString("tr-TR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
      return fulldate;
    } else {
      return null
    }
  },
  moneyformat: function (m) {
    if (m == null || m == '') {
      m = 0
    }
    return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
  },

  currencyformat: function (m) {
    if (m == null || m == '') {
      m = 0
    }
    return m.toFixed(4)
  },

  getYear() {
    var today = new Date();
    var yyyy = today.getFullYear();
    return yyyy
  },

  getTimeNow() {

    var time = new Date();
    var fullclock = time.toLocaleTimeString("tr-TR", {
      hour: "numeric",
      minute: "2-digit",
      //second: "2-digit",
    });
    return fullclock;

  },

  getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },
  getDatYear() {
    var today = new Date();
    var yyyy = today.getFullYear();
    today = yyyy + '-' + '01' + '-' + '01'
    return today
  },


  bakiyekontrol: function (m) {
    var c = parseFloat(m);
    if (c < 0) {
      var c = c * -1;
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + ' A ';
    } else if (c > 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + ' B '
    } else if (c == 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }
  },
  bakiyekontrolsimgeli: function (m) {
    var c = parseFloat(m);
    if (c < 0) {
      var c = c * -1;
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + this.getparabirimi() + ' A ';
    } else if (c > 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + this.getparabirimi() + ' B '
    } else if (c == 0) {
      return c.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + this.getparabirimi()
    }
  },

  mailkontrol: function (email) {

    var re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var kont = re.test(email)
    if (kont == true) {
      return true;
    } else {
      return false;
    }
  },

  yetkilisirketlerigetir: function (sirketler) {

    var list = []
    sirketler.forEach(element => {
      if (element.UserTip == 1) {
        list.push(element)
      }
    });
    return list;
  },


  yetkisorgula(sirketkod, sirketler) {

    if (sirketkod == null) {
      var durum = false
      sirketler.forEach(element => {
        if (element.UserTip == 1) {
          durum = true
        }
      });
      return durum;
    } else {

    }

  },

  defaultKod(length) {

    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      const rnd = Math.floor(Math.random() * 90000) + 10000;
      return result + rnd;
    }
  },

  pageScreenAuth(page) {


    var yetkiler = {
      Screen: false,
      Update: false,
      Save: false,
      Delete: false,
      Status: false,
      Message: null,
      islem: 0, // 0:bir önceki sayfaya gidecek, 1: anaşirketseçimiyapacak, 2:çıkış yapması gerekir
    }

    var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    var cred = JSON.parse(window.localStorage.getItem('credentials'));

    if (page != null) {

      if (page != 'login' && page != 'register' && page != 'anasirket' && page != 'login-uye' && page != 'uye-detay' && page != 'uye-yeni' && page != 'login-yetkigrup' && page != 'login-yetkigruplist' && page != 'confirm') {



        if (cred != null && manage != null) {


          if (cred.SirketKodu != null && cred.AnaSirketKodu != null) {

            var anasirketvarmi = false

            manage.AnaSirketInfo.forEach(element => {

              if (element.MusteriKod == cred.AnaSirketKodu) {

                anasirketvarmi = true

                var altsirketvarmi = false

                if (element.YetkiInfo != null) {
                  element.YetkiInfo.forEach(element1 => {

                    if (element1.SirketNo == cred.SirketKodu) {
                      altsirketvarmi = true

                      var index = element1.SayfaYetkiInfo.map(function (e) {
                        return e.PageName;
                      }).indexOf(page);

                      if (index != -1) {
                        yetkiler.Status = true
                        yetkiler.Screen = element1.SayfaYetkiInfo[index].Screen
                        yetkiler.Save = element1.SayfaYetkiInfo[index].Save
                        yetkiler.Update = element1.SayfaYetkiInfo[index].Update
                        yetkiler.Delete = element1.SayfaYetkiInfo[index].Delete


                        if (element1.SayfaYetkiInfo[index].Screen == false) {
                          yetkiler.Status = false
                          yetkiler.islem = 0
                          yetkiler.Message = 'Bu sayfayı görüntüleme yetkiniz bulunmamaktadır, lütfen admin kullanıcınızdan yetki talep ediniz.'
                        }
                      } else {
                        yetkiler.Status = false
                        this.islem = 0
                        yetkiler.Message = 'Bu şirket için yetkileriniz tanımlanmamış, lütfen admin kullanıcınızdan yetki talep ediniz.'
                        yetkiler.Screen = false
                        yetkiler.Save = false
                        yetkiler.Update = false
                        yetkiler.Delete = false
                      }

                    }

                    if (altsirketvarmi != true) {
                      yetkiler.Status = false;
                      yetkiler.Screen = false
                      yetkiler.Save = false
                      yetkiler.Update = false
                      yetkiler.Delete = false
                      yetkiler.Message = 'Bu sayfa için alt şirketinize ait yetki bulunamadı, lütfen admin kullanıcınızdan yetki talep ediniz.'
                      this.islem = 0
                    }

                  });
                } else {
                  window.alert('Kullanıcı yetki bilgileri bulunamadı, lütfen admin kullanıcınıza başvurunuz.')
                }
              }

              if (anasirketvarmi != true) {
                yetkiler.Status = false;
                yetkiler.Screen = false
                yetkiler.Save = false
                yetkiler.Update = false
                yetkiler.Delete = false
                yetkiler.Message = 'Ana şirket bilgilerine ulaşılamadı, lütfen ana şirket seçimi yapınız.'
                yetkiler.islem = 1
              }
            });
          } else {
            yetkiler.Status = false;
            yetkiler.Screen = false
            yetkiler.Save = false
            yetkiler.Update = false
            yetkiler.Delete = false
            yetkiler.Message = 'Şirket bilgilerine ulaşılamadı, lütfen şirket seçimi yapınız.'
            yetkiler.islem = 1
          }

        } else {
          yetkiler.Status = false;
          yetkiler.Screen = false
          yetkiler.Save = false
          yetkiler.Update = false
          yetkiler.Delete = false
          yetkiler.Message = 'Yetki ile ilgili gerekli bilgilere ulaşılamadı, lütfen giriş çıkış yapınız.'
          yetkiler.islem = 2
        }
      } else {
        yetkiler.Screen = true
        yetkiler.Save = true
        yetkiler.Update = true
        yetkiler.Delete = true
      }

    } else {
      yetkiler.Status = false;
      yetkiler.Screen = false
      yetkiler.Save = false
      yetkiler.Update = false
      yetkiler.Delete = false
      yetkiler.islem = 0
      yetkiler.Message = 'Sayfa bilgilerine ulaşılamadı, lütfen sayfaya yeniden giriş yapınız..'
    }

    // console.log(' Görüntüle: ' + yetkiler.Screen)

    // console.log('Kaydet: ' + yetkiler.Save)


    // console.log('Update: ' + yetkiler.Update)


    // console.log('Sil: ' + yetkiler.Delete)


    // console.log('Status: ' + yetkiler.Status)


    // console.log('islem: ' + yetkiler.islem)


    // console.log('mesaj: ' + yetkiler.Message)

    return yetkiler
  },

  turkceUpperCase(word) {
    return word.toLocaleUpperCase('TR');
  }

}